import type { ReactNode } from 'react'
import { Press } from '@dorixona/ui'
import { Icon } from './Icon'

export interface DetailHeadProps {
  /** Куда возвращает стрелка: название раздела, оно же подсказка у стрелки. */
  backLabel: string
  onBack: () => void
  title: string
  /** Строка состояния под названием: статус, дата, метки. */
  sub: ReactNode
  /** Действия справа; их может не быть — например, у завершённого заказа. */
  actions?: ReactNode
  /** Лицо карточки слева от названия: инициалы клиента, фото. */
  avatar?: ReactNode
}

/**
 * Шапка карточки: возврат, название, состояние и действия. Название — это
 * заголовок страницы: на карточке каркас свой заголовок раздела не рисует,
 * иначе сверху стояли бы «Товары», хлебная крошка и название друг под другом.
 *
 * Возврат — тихая кнопка с названием раздела над заголовком, а не квадрат
 * рядом с ним: квадрат спорил с названием и сдвигал строку состояния вправо.
 */
export function DetailHead({ backLabel, onBack, title, sub, actions, avatar }: DetailHeadProps) {
  return (
    <div className="ui-dhead">
      <Press
        as="button"
        type="button"
        className="ui-btn back"
        data-variant="ghost"
        data-size="sm"
        squish="icon"
        aria-label={`Назад: ${backLabel}`}
        onPress={onBack}
      >
        <Icon name="i-back" />
        {backLabel}
      </Press>
      <div className="row">
        {avatar ? <div className="face">{avatar}</div> : null}
        <div className="main">
          <h1>{title}</h1>
          <div className="sub">{sub}</div>
        </div>
        {actions ? <div className="acts">{actions}</div> : null}
      </div>
    </div>
  )
}
